export default {
  namespaced: true,
  state: {
    bookInfo: {},
    keyWord: ''
  },
  getters: {
    getBookInfo: state => {
      return state.bookInfo
    },
    getKeyWord: state => {
      return state.keyWord
    }
  },
  mutations: {
    setBookInfo (state, bookInfo) {
      state.bookInfo = bookInfo
    },
    setKeyWord (state, bookInfo) {
      state.keyWord = bookInfo
    }
  }
}
